import { generateDynamicThemeToken } from '../../ThemeProvider';
import { getDynamicThemeToken } from './theme';
import { randomStr } from '../../Shared';
const componentName = 'Radio';
const classPrefix = `ui-${componentName}`;
export const radioClasses = {
    root: `${classPrefix}-root-${randomStr()}`,
    title: `${classPrefix}-title`,
    base: `${classPrefix}-base`,
    label: `${classPrefix}-label`,
    endIcon: `${classPrefix}-end-icon`,
    disabled: `${classPrefix}-disabled`,
    icon: `${classPrefix}-icon`,
    checkedIcon: `${classPrefix}-checked-icon`,
    description: `${classPrefix}-description`,
};
export function getStyled(theme) {
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName,
        theme,
        dynamicToken,
    });
    const rootStyle = {
        [`&.${radioClasses.root}`]: {
            display: 'inline-flex',
            flexDirection: 'column',
            [`.${radioClasses.title}`]: {
                display: 'inline-flex',
                alignItems: 'flex-start',
                cursor: 'pointer',
                fontFamily: tk(token.fontFamily),
                alignSelf: 'baseline',
            },
            [`.${radioClasses.base}`]: {
                padding: tk(token.base.padding),
            },
            [`.${radioClasses.label}`]: {
                display: 'inline-flex',
                alignItems: 'center',
                marginInlineStart: tk(token.label.marginLeft),
                color: tk(token.label.color),
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '20px',
            },
            [`& .${radioClasses.endIcon}`]: {
                display: 'inline-block',
                marginInlineStart: tk(token.endIcon.marginLeft),
            },
            [`& .${radioClasses.description}`]: {
                marginInlineStart: tk(token.base.width + token.base.padding * 2 + token.label.marginLeft),
                ...token.description,
                '&:empty': {
                    display: 'none',
                },
            },
            [`&.${radioClasses.disabled}`]: {
                cursor: 'not-allowed',
                [`.${radioClasses.label}`]: {
                    color: tk(token.label.disabled.color),
                },
                [`.${radioClasses.description}`]: {
                    color: tk(token.label.disabled.color),
                },
            },
        },
    };
    return rootStyle;
}
export function getRadioIconStyle(theme) {
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName,
        theme,
        dynamicToken,
    });
    return {
        borderRadius: '50%',
        width: tk(token.base.width),
        height: tk(token.base.height),
        border: `1px solid ${tk(token.borderColor.default)}`,
        boxSizing: 'border-box',
        'input:hover ~ &': {
            borderColor: tk(token.borderColor.hover),
            backgroundColor: tk(token.background.hover),
        },
        'input:active ~ &': {
            borderColor: tk(token.borderColor.active),
            backgroundColor: tk(token.background.active),
        },
        'input:focus-visible ~ &': {
            boxShadow: tk(token.radioFocusBoxShadow),
        },
        [`input ~ &.${radioClasses.disabled}`]: {
            borderColor: tk(token.borderColor.disabled),
            backgroundColor: tk(token.background.disabled),
        },
    };
}
export function getSelectedRadioIcon(theme) {
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName,
        theme,
        dynamicToken,
    });
    return {
        borderRadius: '50%',
        width: tk(token.base.width),
        height: tk(token.base.height),
        '&::before': {
            boxSizing: 'border-box',
            display: 'block',
            border: `4px solid ${tk(token.selected.borderColor.default)}`,
            backgroundColor: tk(token.selected.dot.background),
            borderRadius: '50%',
            width: tk(token.base.width),
            height: tk(token.base.height),
            content: '""',
        },
        'input:hover ~ &::before': {
            borderColor: tk(token.selected.borderColor.hover),
        },
        'input:active ~ &::before': {
            borderColor: tk(token.selected.borderColor.active),
        },
        'input:focus-visible ~ &::before': {
            boxShadow: tk(token.radioFocusBoxShadow),
        },
        [`input ~ &.${radioClasses.disabled}::before`]: {
            borderColor: tk(token.selected.borderColor.disabled),
        },
    };
}
